import Axios from 'util/service';
import { get, flatMap, inRange, cloneDeep } from 'lodash';
import cmsPlugin from 'vue/mixins/cms/cms-plugin/index';
import bemMixin from 'vue/mixins/bem';


const SUCCESS_CODE_LIMITS = [200, 300];


export default {
    mixins: [
        cmsPlugin,
        bemMixin('form'),
    ],
    data() {
        return {
            isSubmitting: false,
            protectedFieldsets: [],
            generalErrors: [],
        };
    },
    methods: {
        handleFormSubmit() {
            if (this.isSubmitting) {
                return;
            }

            this.isSubmitting = true;

            const formData = new FormData(this.$el);

            Axios
                .post(this.content.url, formData, {
                    validateStatus: function(status) {
                        return inRange(status, ...SUCCESS_CODE_LIMITS);
                    },
                })
                .then(
                    () => {
                        this.$router.push(this.content.success_url);
                        this.isSubmitting = false;
                    },
                    ({ response }) => {
                        const fieldErrors = get(response, 'data.fields');
                        const generalError = get(response, 'data.messages.error');

                        if (response.status === 400 && (fieldErrors || generalError)) {
                            // NOTE: Show field errors
                            this.setFieldErrors(fieldErrors);
                            this.setGeneralError(generalError);
                        } else {
                            // NOTE: Show generic error message
                            this.setGeneralError([`${ response.status } - ${ response.statusText }`]);
                        }

                        this.isSubmitting = false;
                    }
                );
        },
        setGeneralError(generalErrors = []) {
            if (!generalErrors.length) {
                return;
            }

            this.generalErrors = generalErrors;
        },
        setFieldErrors(fieldErrors) {
            const fields = flatMap(this.protectedFieldsets, (item) => item.fields) || [];

            fields.forEach((field) => {
                const updatedFieldData = fieldErrors.find(fieldError => fieldError.id === field.id);

                if (!field.id) {
                    return;
                }

                this.$set(field.messages, 'error', get(updatedFieldData, 'messages.error', []));
                this.$set(field.state, 'error', get(updatedFieldData, 'state.error', false));
            });
        },
    },
    watch: {
        'content.fieldsets': {
            handler(newVal) {
                this.protectedFieldsets = cloneDeep(newVal);
            },
            immediate: true,
        },
    },
};



// WEBPACK FOOTER //
// ./sib-website/assets/src/js/app/vue/mixins/form/form/index.js